import { IWindowData } from '@/editor/data/model/model';
import { getWallSplitPoints } from '../../utils';
import { EEntityType } from '@/editor/types';
import { Point2dUtils } from '@/editor/math/Point2dUtils';
import { getRangeIndex } from '@/editor/utils/ruler/doorWindow';
import { DEFAULT_RULER_OFFSET } from '@/editor/constant/ruler';
import { IRulerInfo } from '@/editor/entities/2d/rulerModel';

export function calculateWindowDoorRulerInfos(wdData: IWindowData): IRulerInfo[] {
  if (!wdData.relativeWallInfo.relativeWallId) return [];

  const wallSplitPoints = getWallSplitPoints(
    wdData.relativeWallInfo.relativeWallId,
    wdData.relativeWallInfo.wallType || EEntityType.Wall
  );

  if (wallSplitPoints.length < 2) return [];

  const wallDirection = Point2dUtils.getDirection(wallSplitPoints[0], wallSplitPoints[wallSplitPoints.length - 1]);
  const wdStartPoint = Point2dUtils.addDistance(wdData.center, -wdData.width / 2, wallDirection);
  const wdEndPoint = Point2dUtils.addDistance(wdData.center, wdData.width / 2, wallDirection);
  const wdStartIndex = getRangeIndex(wallSplitPoints, wdStartPoint);
  const wdEndIndex = getRangeIndex(wallSplitPoints, wdEndPoint);

  const rulerInfos = [];
  let start;
  let end;
  if (typeof wdStartIndex === 'number' && wdStartIndex > -1) {
    start = wallSplitPoints[wdStartIndex];
    end = wdStartPoint;

    // 避免长度为0的情况
    if (Point2dUtils.equals(start, end)) {
      end = Point2dUtils.addDistance(start, 0.001, wallDirection);
    }

    rulerInfos.push({ id: 's', start, end, offset: wdData.thickness / 2 + DEFAULT_RULER_OFFSET });
  }

  if (typeof wdEndIndex === 'number' && wdEndIndex < wallSplitPoints.length - 1) {
    start = wdEndPoint;
    end = wallSplitPoints[wdEndIndex + 1];

    // 避免长度为0的情况
    if (Point2dUtils.equals(start, end)) {
      start = Point2dUtils.addDistance(end, -0.001, wallDirection);
    }

    rulerInfos.push({ id: 'e', start, end, offset: wdData.thickness / 2 + DEFAULT_RULER_OFFSET });
  }

  return rulerInfos;
}
